import React from 'react';

import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import useStyles from './styles';

const InputSwitch = ({ value, label, disabled, onChange }) => {
  const classes = useStyles();

  const handleChange = (event) => {
    const { checked } = event.target;
    onChange(checked);
  };

  return (
    <>
      <FormControlLabel
        control={<Switch checked={value} onChange={handleChange} />}
        disabled={disabled}
        className={classes.text}
        label={label}
      />
    </>
  );
};

export default InputSwitch;
